import { parseSearchParams } from '../utils/url';

export const getUuid = () => {
    const urlParams = parseSearchParams(window.location.hash);
    return urlParams.id;
};

const VALID_SIGNUP_TYPES = ['partner', 'agency'];

export const getSignupType = () => {
    const urlParams = parseSearchParams(window.location.hash);
    const { type } = urlParams;
    return VALID_SIGNUP_TYPES.includes(type) ? type : undefined;
};
